import React, { useEffect, useRef } from 'react'
import IndividualResourcePrintControlsComponent from './component'

const IndividualResourcePrintControls = () => {
  // Safari can drop the initial print request; track whether print started so retries only run when needed.
  const safariPrintStartedRef = useRef(false)
  const safariPrintTimeoutRef = useRef(null)

  useEffect(() => {
    const handleBeforePrint = () => {
      safariPrintStartedRef.current = true
      if (safariPrintTimeoutRef.current) {
        window.clearTimeout(safariPrintTimeoutRef.current)
        safariPrintTimeoutRef.current = null
      }
    }

    window.addEventListener('beforeprint', handleBeforePrint)

    return () => {
      window.removeEventListener('beforeprint', handleBeforePrint)
      if (safariPrintTimeoutRef.current) {
        window.clearTimeout(safariPrintTimeoutRef.current)
      }
    }
  }, [])

  const handlePrint = () => {
    if (typeof window === 'undefined' || typeof window.print !== 'function') {
      return
    }

    const userAgent = window.navigator?.userAgent || ''
    const isSafari =
      /Safari/i.test(userAgent) &&
      !/Chrome|CriOS|Edg|OPR|Firefox|FxiOS/i.test(userAgent)

    safariPrintStartedRef.current = false
    window.focus()
    window.print()

    if (isSafari) {
      // Avoid duplicate dialogs: only retry once after a short delay if print never starts.
      if (safariPrintTimeoutRef.current) {
        window.clearTimeout(safariPrintTimeoutRef.current)
      }

      safariPrintTimeoutRef.current = window.setTimeout(() => {
        if (!safariPrintStartedRef.current) {
          window.print()
        }
        safariPrintTimeoutRef.current = null
      }, 300)

      if (typeof document.execCommand === 'function') {
        try {
          document.execCommand('print', false, null)
        } catch (error) {
          // eslint-disable-next-line no-console
          console.warn(
            'IndividualResourcePrintControls: document.execCommand("print") is not supported.',
            error,
          )
        }
      }
    }
  }

  return <IndividualResourcePrintControlsComponent onPrint={handlePrint} />
}

export default IndividualResourcePrintControls
